
import { useSelector } from 'react-redux';
import { useShopDetailsData } from '../../API_Master/GetAPI';
import Cookies from "js-cookie"
import DailyCloseLogs from './DailyCloseLogs';
import ActionHistory from './ActionHistory';
import { NIGHT_EYE_IMG_URL } from '../../Process';
import { Navigate, useNavigate } from 'react-router-dom';
import { mainRouteInitial } from '../../Data/Constant';
import VendorDashboardHeader from '../../Components/VendorDashboardHeader';
// Sample data - in real app this would come from props or context/state


const MyShop = () => {
  const { shopDetailID } = useSelector(state => state.ProjectSlice)
  const navigate = useNavigate()
  const { data: myShopData = [] } = useShopDetailsData(shopDetailID, Cookies.get("NIGHT_EYE_USER_ID"));
  const shopData = myShopData?.[0] || {}
  const owner = shopData?.ShopUserDetail?.[0] || {};
  const helper = shopData?.ShopHelperDetail?.[0] || {};
  const amenities = shopData?.ShopAmenitiesDetail || [];
    // const isUserShop =Cookies.get("NIGHT_EYE_USER_ROLE")?.toLowerCase()=="shopuser"
  
  // const handleRegisterNewShop =()=>{
  //   console.log(shopData.IsStep1,"jhjkhjkhk")
  //   Cookies.set("IsStep1Completed",shopData.IsStep1 || false)
  //   Cookies.set("IsStep2Completed",shopData.IsStep2 || false)
  //   Cookies.set("IsStep3Completed",shopData.IsStep3 || false)
  //   Cookies.set("NIGHT_EYE_SHOP_DETAIL_ID",shopDetailID)
  //   navigate(`/${mainRouteInitial}/VendorRegistration`)
  // }
  const handleGoBack = () => {
    navigate(-1); // Go back to previous page
    // Alternative: navigate(`/${mainRouteInitial}/VendorDashboard`);
  };
  return (
    shopDetailID ? <div>
      {/* Header - kept almost same */}
     <VendorDashboardHeader />

      <main className="flex-1 p-6 md:px-10 md:py-5 mx-auto">
        {/* Shop Header */}
       <button
              onClick={handleGoBack}
              className="
                flex items-center gap-2 
                px-4 py-2 mb-4 mt-0
                text-slate-700 dark:text-slate-300 
                hover:text-indigo-600 dark:hover:text-indigo-400
                bg-white dark:bg-slate-800 
                border border-slate-300 dark:border-slate-700 
                rounded-lg 
                shadow-sm 
                hover:shadow 
                transition-all
              "
            >
              <svg 
                className="w-5 h-5" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M10 19l-7-7m0 0l7-7m-7 7h18" 
                />
              </svg>
              <span className="font-medium">Back</span>
            </button>
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-8">
        
          <div className="flex gap-4">
              
            <div
              className="hidden sm:block size-16 rounded-xl bg-slate-200 dark:bg-slate-700 bg-center bg-cover border border-slate-300 dark:border-slate-600 shrink-0"
              style={{ backgroundImage: `url(${NIGHT_EYE_IMG_URL}/SmartCollection/ShopImage/${shopData.ShopImage})` }}
              // style={{ backgroundImage: `url("/shop-images/${shopData?.ShopImage}")` }}
            />
            <div>
            
              <div className="flex items-center gap-3 flex-wrap">
             
                <h1 className="text-3xl font-bold text-slate-900 dark:text-white tracking-tight">
                  {shopData?.ShopName}
                </h1>
                <span className="inline-flex items-center rounded-full bg-emerald-100 dark:bg-emerald-900/40 px-2.5 py-0.5 text-xs font-semibold text-emerald-800 dark:text-emerald-300 ring-1 ring-inset ring-emerald-600/20">
                  {shopData?.ShopVerifiedStatus === "true" ? "Verified" : "Pending"}
                </span>
              </div>
              <p className="mt-1 text-slate-500 dark:text-slate-400">
                {/* Shop ID: {shopData?.ShopDetailID}  */}
                • Registered: {shopData?.CreatedDate?.split(' ')?.[0]}
              </p>
            </div>
          </div>

          <div className="flex gap-3">
            {/* <button className="flex items-center gap-2 rounded-lg bg-white dark:bg-slate-800 px-4 py-2 text-sm font-semibold text-slate-700 dark:text-slate-200 shadow-sm ring-1 ring-inset ring-slate-300 dark:ring-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
              <span className="material-symbols-outlined text-[20px]">print</span>
              Print Report
            </button> */}
           {/* {isUserShop && <button onClick={handleRegisterNewShop} className="flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 transition-colors">
              <span className="material-symbols-outlined text-[20px]">edit</span>
              Edit Details
            </button>} */}
          </div>
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          {/* Shop Details Card */}
          <div className="lg:col-span-2 bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
            <div className="px-6 py-4 border-b border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50">
              <h3 className="text-base font-semibold text-slate-900 dark:text-white">Shop Registration Details</h3>
            </div>
            <div className="p-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-6 gap-x-8">
              <div>
                <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">Owner Name</dt>
                <dd className="mt-1 text-sm font-medium text-slate-900 dark:text-white">{owner.ShopUserName || '-'}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">Contact Numbers</dt>
                <dd className="mt-1 text-sm font-medium text-slate-900 dark:text-white">
                  {shopData?.ShopMobileNo1}
                  {shopData?.ShopMobileNo2 && ` | ${shopData?.ShopMobileNo2}`}
                </dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">Operating Hours</dt>
                <dd className="mt-1 text-sm font-medium text-slate-900 dark:text-white flex items-center gap-2">
                  <span className="material-symbols-outlined text-[16px] text-slate-400">schedule</span>
                  {shopData?.ShopOpenTime} - {shopData?.ShopCloseTime}
                </dd>
              </div>
              <div className="md:col-span-2">
                <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">Address</dt>
                <dd className="mt-1 text-sm font-medium text-slate-900 dark:text-white flex items-start gap-2">
                  <span className="material-symbols-outlined text-[16px] text-slate-400 mt-0.5">location_on</span>
                  {shopData?.Address}
                </dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">Helper</dt>
                <dd className="mt-1 text-sm font-medium text-slate-900 dark:text-white">
                  {helper.HelperName || '-'} ({helper.HelperMobileNo || '-'})
                </dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-slate-500 dark:text-slate-400">Registration Date</dt>
                <dd className="mt-1 text-sm font-medium text-slate-900 dark:text-white">
                  {shopData?.CreatedDate?.split(' ')?.[0]}
                </dd>
              </div>
            </div>
          </div>

          {/* Amenities Card */}
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden flex flex-col h-full">
            <div className="px-6 py-4 border-b border-slate-200 dark:border-slate-800 flex justify-between items-center bg-slate-50/50 dark:bg-slate-900/50">
              <h3 className="text-base font-semibold text-slate-900 dark:text-white">Amenities</h3>
            </div>
            <div className="flex-1 divide-y divide-slate-100 dark:divide-slate-800 overflow-y-auto">
              {amenities.length === 0 ? (
                <div className="p-6 text-center text-slate-500 dark:text-slate-400">No amenities recorded</div>
              ) : (
                amenities.map((amenity, index) => {
                  const subDetails = amenity.ShopAmenitiesSubDetail || [];
                  const mainStatus = subDetails.find(s => s.AmenitiesSubTypeName.includes("Working") || s.AmenitiesSubTypeName === "Working");
                  const statusColor = mainStatus?.AmenitiesSubTypeName.includes("Not") ? "red" : "emerald";

                  return (
                    <div key={index} className="p-4 flex items-start gap-4 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                      <div className={`size-10 rounded-lg bg-${statusColor}-50 dark:bg-${statusColor}-900/20 text-${statusColor}-600 dark:text-${statusColor}-400 flex items-center justify-center shrink-0 border border-${statusColor}-100 dark:border-${statusColor}-800/50`}>
                        <span className="material-symbols-outlined">
                          {amenity.AmenitiesName.includes("CCTV") ? "videocam" : "light_mode"}
                        </span>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between items-start mb-1">
                          <p className="font-medium text-slate-900 dark:text-white truncate">{amenity.AmenitiesName}</p>
                          <span className="inline-flex items-center rounded-md bg-slate-100 dark:bg-slate-800 px-2 py-0.5 text-xs font-medium text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-700">
                            {amenity.IsAvailable ? "Yes" : "No"}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className={`flex size-2 rounded-full bg-${statusColor}-500 ${mainStatus ? "animate-pulse" : ""}`} />
                          <p className="text-xs text-slate-500 dark:text-slate-400">
                            Status: <span className={`font-medium text-${statusColor}-600 dark:text-${statusColor}-400`}>
                              {mainStatus?.AmenitiesSubTypeName || "Unknown"}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>

        {/* Tracking & Reports */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <DailyCloseLogs />

          {/* Action History / Reports */}
          <ActionHistory />
        </div>
      </main>
    </div> : <Navigate to={`/${mainRouteInitial}/VendorDashboard`} />
  );
};

export default MyShop;